module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about-us awards",
    attrs: {
      "id": "awards"
    }
  }, [_c('header', {
    staticClass: "page-header",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "heading-text",
    attrs: {
      "data-aos": "fade-up"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('certs.headingTopText'))
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "certs"
  }, _vm._l((_vm.certs), function(cert) {
    return _c('div', {
      key: cert.key,
      staticClass: "elements",
      on: {
        "click": function($event) {
          _vm.openCert(cert)
        }
      }
    }, [_c('img', {
      staticClass: "isoDetails",
      attrs: {
        "src": cert.img,
        "alt": cert.alt
      }
    })])
  }), 0), _vm._v(" "), _c('footer-main')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "video-container"
  }, [_c('video', {
    staticClass: "header-video",
    attrs: {
      "src": "static/img/about-us/falcon.mp4",
      "autoplay": "",
      "loop": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1081880e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Certificates.vue
// module id = 277
// module chunks = 0